import { Box, Button, Center, List, ListItem, VStack } from '@chakra-ui/react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { SuggestionInfo } from '../../../hooks/suggested-resources';
import SparkelIcon from '../../common/icon/SparkelIcon';
import PlaceholderText from '../../text/PlaceholderText';

type SuggestedResourceProps = {
  suggestedResources: SuggestionInfo[];
  onAddSuggestedResources: (suggested: SuggestionInfo[]) => void;
};

export default function SuggestedResourceList({
  suggestedResources,
  onAddSuggestedResources,
}: SuggestedResourceProps) {
  if (suggestedResources.length === 0) {
    return (
      <Center flex={1}>
        <PlaceholderText>No automatic suggestions found</PlaceholderText>
      </Center>
    );
  } else {
    return (
      <Box
        borderRadius="md"
        fontSize="sm"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <VStack alignItems="flex-start">
          <PlaceholderText as="p" fontWeight="semibold">
            Suggested items:
          </PlaceholderText>
          <List display="flex" flexDirection="column">
            {suggestedResources.map((suggestion) => (
              <ListItem
                key={suggestion.suggestionLabel}
                display="inline-flex"
                flexDirection="row"
                alignItems="center"
                gap={1}
              >
                <Button
                  leftIcon={
                    <SparkelIcon
                      icon={faPlus}
                      color={['gray.400', 'gray.500']}
                    />
                  }
                  variant={'ghost'}
                  size={'xs'}
                  color={['gray.50', 'gray.400']}
                  onClick={() => onAddSuggestedResources([suggestion])}
                >
                  {suggestion.suggestionLabel}
                </Button>
              </ListItem>
            ))}
          </List>
        </VStack>
      </Box>
    );
  }
}
